/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useParams } from 'react-router-dom';
import '../css/custom-responsive.css';
import '../css/custom.css';
import BaseUrls from '../utils/baseUrls';
import CustomStyle from '../css/customStyle';
import AddCloudBody from '../components/addCloud/addCloudBody';

const AddCloud = () => {
  const { id, cloud } = useParams<{ id: string, cloud:string }>();

  const theme = BaseUrls.getkey();
  const setCustomStyle = () => {
    let customStyle = '';
    switch (theme) {
      case 'zeeve':
        customStyle = CustomStyle.customZeeveStyle();
        break;
      case 'helious':
        customStyle = CustomStyle.customHeliosStyle();
        break;
      case 'phaeton':
        customStyle = CustomStyle.customHeliosStyle();
        break;
      default:
        break;
    }
    return customStyle;
  };

  return (
        <body>
          <style>{setCustomStyle()}</style>
          {id && cloud
            && <AddCloudBody id={id} cloud={cloud} />}
        </body>

  );
};

export default AddCloud;
